import { useActivitySummaryContext } from '@user/features/Activity/ActivitySummary/context'
import { setEditActivityIdActionCreator } from '@user/features/Activity/ActivitySummary/state'
import { useCallback } from 'react'

type Props = {
  activityId: number
  onClose: () => void
}

export function useHandlers(props: Props) {
  const { activityId, onClose } = props
  const [, dispatch] = useActivitySummaryContext()

  const onClick = useCallback(() => {
    dispatch(setEditActivityIdActionCreator(activityId))
    onClose()
  }, [activityId, dispatch, onClose])

  return {
    onClick,
  }
}
